import {
  Coords,
  centerAround,
  composeSlides,
  getCenter,
} from '@features/powerpoint';
import { circleGraphic } from './components/circle-graphic';
import { stepText } from './components/step-text';
import { baseSlide } from './base-slide';

const CIRCLE_GRAPHIC_WIDTH = 3;
const COLUMN_X_POSITIONS = [2, 8.33] as const;
const STEP_TEXT_WIDTH = CIRCLE_GRAPHIC_WIDTH * 1.8;
const STEP_TEXT_Y = 1.5;
const CIRCLE_GRAPHIC_Y = 3.25;

const FULL_EXPOSED_POSITION: Coords = {
  x: COLUMN_X_POSITIONS[0],
  y: CIRCLE_GRAPHIC_Y,
};
const TOTAL_PROJECTED_POSITION: Coords = {
  x: COLUMN_X_POSITIONS[1],
  y: CIRCLE_GRAPHIC_Y,
};

export const projectedVisitsMethodologySlide = () => {
  return composeSlides(
    baseSlide(),
    stepText(
      '<b>Step 1:</b> Measure the Full Exposed Population',
      'The campaign match rate multiplier is calculated to measure the ratio between exposed users to InMarket universe and all exposed users',
      {
        x: centerAround(
          getCenter({
            ...FULL_EXPOSED_POSITION,
            h: 0,
            w: CIRCLE_GRAPHIC_WIDTH,
          }),
          {
            h: 0,
            w: STEP_TEXT_WIDTH,
          }
        ).x,
        y: STEP_TEXT_Y,
      }
    ),
    stepText(
      '<b>Step 2:</b> Measure the Total Projected Store Visits',
      'The total projected store visits are calculated by applying the campaign match rate multiplier ratio to exposed visits observed by InMarket',
      {
        x: centerAround(
          getCenter({
            ...TOTAL_PROJECTED_POSITION,
            h: 0,
            w: CIRCLE_GRAPHIC_WIDTH,
          }),
          {
            h: 0,
            w: STEP_TEXT_WIDTH,
          }
        ).x,
        y: STEP_TEXT_Y,
      }
    ),
    circleGraphic({
      title: 'Full Exposed Population',
      group: 'Exposed users to InMarket universe',
      multiplierDescription: 'Campaign Match Rate Multiplier Calculated (x)',
      position: FULL_EXPOSED_POSITION,
      width: CIRCLE_GRAPHIC_WIDTH,
      baseColor: 'FF9D1D',
      highlightColor: 'F4B081',
    }),
    circleGraphic({
      title: 'Total Projected Store Visits',
      group: 'Exposed visits observed by InMarket',
      multiplierDescription: 'Campaign Match Rate Multiplier Applied (x)',
      position: TOTAL_PROJECTED_POSITION,
      width: CIRCLE_GRAPHIC_WIDTH,
      baseColor: '7DBF42',
      highlightColor: 'A8D08C',
    })
  );
};
